import React from "react";
import { Link } from "react-router-dom";
import Shell from "../components/Shell";
import { UBot } from "../components/UBot";
import { SUPPORT_ENABLED } from "../lib/features";

export function AboutPage() {
  return (
    <Shell>
      <div className="mx-auto w-full max-w-[760px] px-4 py-10">
        <h1 className="font-display text-[34px] font-extrabold text-white">About the showcase</h1>
        <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-white/85">
          <p>In October 2026, builders gathered in Bangkok for U-Hackathon 2026 and shipped 99 projects across AI and Web3, many inspired by U-Bot and the U-Topia ecosystem.</p>
          <p>This showcase lets everyone meet them. Swipe, explore and save the projects you believe in.</p>
        </div>
        {SUPPORT_ENABLED ? (
          <>
            <h2 className="mt-8 font-display text-[22px] font-bold text-white">How support works</h2>
            <p className="mt-2 text-[16px] leading-relaxed text-white/85">
              Pledges are promises, not payments: nothing is charged here. In-kind offers and messages go to the U.Center team, who pass them to the builders. Team emails are never shown publicly.
            </p>
          </>
        ) : (
          <>
            <h2 className="mt-8 font-display text-[22px] font-bold text-white">How it works</h2>
            <p className="mt-2 text-[16px] leading-relaxed text-white/85">
              Swipe right or tap the star to save a project to your favourites, swipe up to open the full story, demo and video, and swipe left to skip. Saved projects live in your Saved list.
            </p>
          </>
        )}
        <p className="mt-6 rounded-lg border border-white/10 bg-white/5 p-4 text-[13px] text-ink-400">Projects are independent entries and not official U-Topia products.</p>
        <Link to="/deck" className="mt-8 inline-block rounded-pill bg-gold-500 px-6 py-3 font-bold text-navy-900">Start swiping</Link>
      </div>
    </Shell>
  );
}

export function PrivacyPage() {
  return (
    <Shell>
      <div className="mx-auto w-full max-w-[760px] px-4 py-10 text-white/85">
        <h1 className="font-display text-[34px] font-extrabold text-white">Privacy</h1>
        <div className="mt-5 space-y-4 text-[16px] leading-relaxed">
          <p>We keep this simple. When you pledge, offer help or message a team, we collect your name, email and any contact handle you share so the U.Center team can reply and connect you with the builders.</p>
          <p>Your details are only shared with the team you chose to support. Team emails are never shown publicly anywhere in this showcase.</p>
          <p>Pledges are promises of support, not payments. We do not collect card, bank or wallet details, and no money moves through this site.</p>
          <p>Saved projects and your support history are stored on your device. If you sign in with a magic link, they sync to your account so you can see them on other devices.</p>
          <p>We record anonymous swipe and open counts to help the organisers understand interest. These are never tied to your identity.</p>
        </div>
      </div>
    </Shell>
  );
}

export function TermsPage() {
  return (
    <Shell>
      <div className="mx-auto w-full max-w-[760px] px-4 py-10 text-white/85">
        <h1 className="font-display text-[34px] font-extrabold text-white">Terms</h1>
        <div className="mt-5 space-y-4 text-[16px] leading-relaxed">
          <p>This showcase is presented by U.Center to celebrate the builders of U-Hackathon 2026.</p>
          <p>Projects are independent hackathon entries by their builders. They aren't official U-Topia products, and some features may be prototypes or simulations. Please do your own research before relying on any project.</p>
          <p>Pledges made here are expressions of intent to support, not binding payments or contracts. Any arrangement is made directly between you and the builders.</p>
          <p>Please be kind and genuine. Messages and offers are relayed to teams, and misuse may be removed.</p>
        </div>
      </div>
    </Shell>
  );
}

export function NotFound() {
  return (
    <Shell>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-center px-4 py-20 text-center" data-testid="not-found">
        <UBot size={120} />
        <h1 className="mt-4 font-display text-[30px] font-extrabold text-white">U-Bot got a little lost 🤖</h1>
        <p className="mt-2 text-on-dark-muted">This page doesn't exist, but 99 projects do.</p>
        <Link to="/deck" className="mt-6 rounded-pill bg-gold-500 px-6 py-3 font-bold text-navy-900">Back to the deck</Link>
      </div>
    </Shell>
  );
}
